export const SET_ACTIVE_CLIENT = 'SET_ACTIVE_CLIENT';
export const SET_ACTIVE_SURVEY = 'SET_ACTIVE_SURVEY';
export const SET_ACTIVE_QUESTION = 'SET_ACTIVE_QUESTION';

/**
 * Salva no store o cliente ativo nos seletores
 * @param {*} param0 client { id:int }
 * @param {*} dispatch função que realiza o dispatch da action
 */
export function setActiveClient(client, dispatch) {
  dispatch({ type: SET_ACTIVE_CLIENT, payload: client });
}

/**
 * Salva no store a pesquisa ativo nos seletores.
 * @param {*} param0 survey { id:int, titulo: string }
 * @param {*} dispatch função que realiza o dispatch da action
 */
export function setActiveSurvey(survey, dispatch) {
  dispatch({ type: SET_ACTIVE_SURVEY, payload: survey });
}

/**
 * Salva no store a questão ativo nos seletores.
 * @param {*} param0 question { id:int, enunciado: string }
 * @param {*} dispatch função que realiza o dispatch da action
 */
export function setActiveQuestion(question, dispatch) {
  dispatch({ type: SET_ACTIVE_QUESTION, payload: question });
}
